module.exports = __webpack_public_path__ + "img/journey-icon.7d52c5bb.svg";